import { useGetIdsHealthcareservicesHcsIdContacts } from '@toktokdoctech/tokapi-client'
import { ChangeEvent, useCallback, useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import AddIcon from '@mui/icons-material/Add'
import { TextField, Button, Hidden, Typography, Box } from '@mui/material'
import _ from 'underscore'
import { Link } from 'react-router-dom'
import styles from '../../Common/_styles/containerListStyles'
import ContactsDataTable from './ContactsDataTable'

import { setDefaultPagination } from '../../../actions/main'
import PageContentHeader from '../../Common/pageContent/PageContentHeader'
import PageContentBody from '../../Common/pageContent/PageContentBody'
import PageContent from '../../Common/pageContent/PageContent'
import { useButtonsStyles, useFormsStyles } from '../../../styles'
import { useAppDispatch } from '../../../store'
import useUserPermissions from '../../../hooks/useUserPermissions'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import MessageState from '../../MessageState/MessageState'
import Loader from '../../Common/Loader/Loader'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { root: { flexGr... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

export default function ContactList() {
    const { hasUserPermission } = useUserPermissions()
    const classes = useStyles()
    const formsClasses = useFormsStyles()
    const buttonsClasses = useButtonsStyles()
    const { id: hcsId } = useCurrentHcs()
    const dispatch = useAppDispatch()
    const [page, setPage] = useState<number>(0)
    const [itemsPerPage, setItemsPerPage] = useState(5)
    const [search, setSearch] = useState('')

    const { isLoading, data } = useGetIdsHealthcareservicesHcsIdContacts(hcsId, {
        skip: page * itemsPerPage,
        limit: itemsPerPage,
        search,
    })

    const count = data?.total ?? 0
    const contacts = data?.items ?? []
    const noContent = count === 0

    const handlePaginationChange = (_event: ChangeEvent<HTMLElement>, value: number) => {
        setPage(value)
    }

    const handleItemsPerPageChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target
        setItemsPerPage(Number(value))
        setPage(0)
        dispatch(setDefaultPagination(value))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleSearchChange = useCallback(
        _.debounce((value: string) => {
            setSearch(value)
            setPage(0)
        }, 300),
        [_.debounce],
    )

    const renderBody = () => {
        if (isLoading) {
            return (
                <Box sx={{ padding: '3rem 0' }}>
                    <Loader title="Chargement des correspondants..." />
                </Box>
            )
        }

        if (noContent) {
            return (
                <Box sx={{ padding: '3rem 0' }}>
                    <MessageState text="Aucun résultat (liste correspondants)" />
                </Box>
            )
        }

        return (
            <ContactsDataTable
                page={page}
                search={search}
                itemsPerPage={itemsPerPage}
                count={count}
                handlePaginationChange={handlePaginationChange}
                handleItemsPerPageChange={handleItemsPerPageChange}
                loading={isLoading}
                data={contacts}
            />
        )
    }

    return (
        <PageContent>
            <PageContentHeader
                left={
                    <div className={classes.textfieldWithTooltip}>
                        <TextField
                            variant="outlined"
                            id="input-with-icon-adornment"
                            data-cy="input-with-icon-adornment"
                            className={formsClasses.SearchField}
                            onChange={(event) => {
                                const { value } = event.target
                                handleSearchChange(value)
                            }}
                            label={
                                <Typography className={formsClasses.SearchFieldLabel}>
                                    <SearchRoundedIcon />
                                    <span>Rechercher par nom, prénom,...</span>
                                </Typography>
                            }
                        />
                    </div>
                }
                right={
                    hasUserPermission('ADMIN') && (
                        <Button
                            className={buttonsClasses.ButtonBlack}
                            startIcon={<AddIcon />}
                            component={Link}
                            to="/contact"
                            data-cy="caregiverCreationForm"
                        >
                            <Hidden smDown>Ajouter</Hidden>
                        </Button>
                    )
                }
            />
            <PageContentBody>{renderBody()}</PageContentBody>
        </PageContent>
    )
}
